import { render, staticRenderFns } from "./CategoryCardSmall.vue?vue&type=template&id=8b928f54&"
import script from "./CategoryCardSmall.vue?vue&type=script&lang=js&"
export * from "./CategoryCardSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports